<template>
	<div>
		<OverviewTitleBox :title="'FINANCE'" class="mb-3"/>
		<div class="" v-if="false">
			<H6 class="title-section">FINANCE</H6>
		</div>
		<div class="row mb-4">
			<div class="col-md-4">
				<InfoCard info="TOTAL CASH DEPOSIT UNCLEARED" :value="totalUncleared" unit="UNIT"
					:url="'/financereport?dateStart=' + clearingStartDate + '&dateEnd=' + clearingEndDate"/>

                <ListItem2 v-if="false" warning=1 title="CASH DEPOSIT UNCLEARED BY AREA" :data="clearing.uncleared" prefix="AREA" itemcol="SalesArea" valuecol="UnitCnt"
					:url="'/financereport?dateStart=' + clearingStartDate + '&dateEnd=' + clearingEndDate"/>

				<ListItem2 warning=1 title="CASH DEPOSIT UNCLEARED BY REGION" :data="clearing.uncleared" tab="20" prefix="REGION" itemcol="RegionPertareId" valuecol="UnitCnt"
					:url="''" />
			</div>

            <div class="col-md-4">
				<InfoCard info="TOTAL EDC UNCLEARED" :value="totalEdcUncleared" unit="UNIT"
					:url="''"/>
                <ListItem2 v-if="false" warning=1 title="EDC UNCLEARED BY AREA" :data="clearingedc.uncleared" prefix="AREA" itemcol="SalesArea" valuecol="UnitCnt"
					:url="''"/>

                <ListItem2 warning=1 title="EDC UNCLEARED BY REGION" :data="clearingedc.uncleared" tab="22" prefix="REGION" itemcol="RegionPertareId" valuecol="UnitCnt"
					:url="''"/>
            </div>

		</div>
	</div>
</template>

<script>
import Finance from '@/components/page/Finance.js'
import ListItem2 from '@/views/pages/ListItem4.vue'
import InfoCard from '@/views/pages/InfoCard.vue'
import OverviewTitleBox from '@/views/component/OverviewTitleBox.vue'

export default{
	extends: Finance,
	components:{
        ListItem2,
		InfoCard,
		OverviewTitleBox,
	},
    mounted(){
		this.loadUncleared();
		this.loadEdcUncleared();
    },
    methods:{
	},
    computed: {
        totalUncleared() {
            return this.clearing.uncleared.reduce((acc, item) => acc + item.UnitCnt, 0);
        },
		totalEdcUncleared() {
            return this.clearingedc.uncleared.reduce((acc, item) => acc + item.UnitCnt, 0);
        },
    }
}

</script>
